<template>
<div>
  <preloader v-if="showPreloader"></preloader>
  <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
    >
      {{allertMessage}}
  </b-alert>
  <camera v-if="showCamera"
    :imagesList="photoType"
    v-on:closecamera="closeCamera">
  </camera>
  <div class="container">
    <base-button v-on:click='goHome' type="primary" size='md' class="my-4">Back</base-button>
  </div>
  <div v-if="!shiftStart && !passedDailyInspection && !shiftIsStarted" class="container">
    <div class="row">
      <div class="offset-md-3 col-md-6">
        <div class="card card-profile shadow">
          <div class="card-body text-center">
            <h5 class="card-title text-center">Click to Start shift</h5>
            <div class="font-xl">
              <button @click="startInspection" class="pointer btn btn-primary"><span class="card-text">Start</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="shiftStart && !passedDailyInspection" class="container">
    <h2 class="text-center">Start shift</h2>
    <h5 class="text-center">Daily Vehicle Inspection</h5>
    <form id="daily_inspection" @submit.prevent="startShift" class="needs-validation">

      <div class="input-group mb-3">
        <input type="text" :class="{'is-invalid': vErrors.first('odometer') }"  class="form-control" v-validate="'required'" data-vv-validate-on="blur" v-model="inspectionData.odometer" name="odometer" placeholder="Enter odometer" aria-label="Recipient's username" aria-describedby="basic-addon2">
        <badge type="primary" class="pull-right custom-badge"><i class="fa fa-paperclip" aria-hidden="true"></i> {{inspectionData.imagesOdometer.length}}</badge>
        <div class="input-group-append">
          <base-button v-on:click='takePicture(["inspectionData", "imagesOdometer"])' type="primary" icon="fa fa-camera"></base-button>
        </div>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('odometer') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="tireTread">Is tire tread OK?</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('tireTread') }" name="tireTread" v-model="inspectionData.tireTread" id="tireTread" v-validate="'required'" data-vv-validate-on="blur" :error="vErrors.first('tireTread')">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option  value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('tireTread') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="brakes">Are brakes functioning</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('brakes') }" name="brakes" v-model="inspectionData.brakes" id="brakes" v-validate="'required'" data-vv-validate-on="blur">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('brakes') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="safetyEquipment">Is all required safety equipment in vehicle?</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('safetyEquipment') }" name="safetyEquipment" v-model="inspectionData.safetyEquipment" id="safetyEquipment" v-validate="'required'" data-vv-validate-on="blur">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('safetyEquipment') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="suppliesSafety">Are proper safety supplies in vehicle?</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('suppliesSafety') }" name="suppliesSafety" v-model="inspectionData.suppliesSafety" id="suppliesSafety" v-validate="'required'" data-vv-validate-on="blur">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('suppliesSafety') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="documentation">Is all proper documentation in vehicle?</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('documentation') }" name="documentation" v-model="inspectionData.documentation" id="documentation" v-validate="'required'" data-vv-validate-on="blur">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('documentation') }}</span>
        </div>
      </div>
      <div class="form-group">
        <label for="lights">Are all lights functioning?</label>
        <select class="form-control" :class="{'is-invalid': vErrors.first('lights') }" name="lights" v-model="inspectionData.lights" id="lights" v-validate="'required'" data-vv-validate-on="blur">
          <option value="" disabled></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
        <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('lights') }}</span>
        </div>
      </div>
      <div class="text-center">
          <base-button :disabled="disableStartShiftButton" type="primary" nativeType='submit' class="my-4">Submit</base-button>
      </div>
    </form>
  </div>
  <div v-if="shiftIsStarted" class="container">
    <div class="row">
      <div class="offset-md-3 col-md-6">
        <div class="card card-profile shadow">
          <div class="card-body text-center">
            <h3 class="card-title text-center">Click to End shift</h3>
            <div class="font-xl">
              <div class="row">
                <div class="col-md">
                  <form @submit.prevent class="needs-validation">
                    <div class="input-group mb-3">
                      <input type="text" :class="{'is-invalid': vErrors.first('endOdometer') }"  class="form-control" v-validate="'required'" data-vv-validate-on="blur" v-model="inspectionData.endOdometer" name="endOdometer" placeholder="Enter odometer" aria-label="Recipient's username" aria-describedby="basic-addon2">
                      <badge type="primary" class="pull-right custom-badge"><i class="fa fa-paperclip" aria-hidden="true"></i> {{inspectionData.imagesOdometerEnd.length}}</badge>
                      <div class="input-group-append">
                        <base-button v-on:click='takePicture(["inspectionData", "imagesOdometerEnd"])' type="primary" icon="fa fa-camera"></base-button>
                      </div>
                      <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                          <span>{{ vErrors.first('odometer') }}</span>
                      </div>
                    </div>
                    <base-button :disabled="disableEndShiftButton" v-on:click='endShift' type="primary">End shift</base-button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!shiftStart && !passedDailyInspection || shiftStart && passedDailyInspection" class="container">
    <div class="row">
      <div class="offset-md-3 col-md-6">
        <div class="card card-profile shadow mt-3">
          <div class="card-body text-center">
            <h5 class="card-title text-center">Recent events</h5>
            <ul class="list-group">
              <li class="list-group-item" v-for="(event, index) in shiftEvents" v-bind:key="index">{{event}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import alertMixin from './../mixins/alertMixin'
import timestampMixin from './../mixins/timestampMixin'
import errorStatusMixin from './../mixins/errorStatusMixin'
import stateUpdateMixin from './../mixins/stateUpdateMixin'
import camera from './../../components/Camera'
export default {
  data () {
    return {
      disableStartShiftButton: false,
      disableEndShiftButton: false,
      showPreloader: false,
      tests: [],
      showCamera: null,
      photoType: null,
      inspectionData: {
        odometer: null,
        imagesOdometer: [],
        tireTread: null,
        brakes: null,
        safetyEquipment: null,
        suppliesSafety: null,
        documentation: null,
        lights: null,
        endOdometer: null,
        imagesOdometerEnd: []
      },
      shiftStart: false,
      passedDailyInspection: false,
      shiftEnd: false,
      shiftEvents: null
    }
  },
  mounted () {
    this.getEvents()
  },
  methods: {
    startBreak () {},
    getEvents () {
      this.shiftEvents = this.$store.state.shift.events
    },
    startInspection () {
      this.shiftStart = true
    },
    async endShift () {
      let self = this
      let time = this.getCurrentTime()
      let shiftId = this.$store.state.shift.id
      this.$validator.validateAll({
        endOdometer: self.inspectionData.endOdometer
      }).then(async function (result) {
        if (result) {
          self.disableEndShiftButton = true
          let images = await self.getImagesFromIndexedDb(self.inspectionData.imagesOdometerEnd)
          let endShiftData = {
            odometer: self.inspectionData.endOdometer,
            imagesOdometer: images,
            shiftId: shiftId,
            time: time
          }
          self.showPreloader = true
          self.$store.dispatch('endShift', endShiftData)
            .then(response => {
              if (response) {
                self.showPreloader = false
                self.disableEndShiftButton = false
                self.showAlert(2, 'Shift has been ended')
                self.saveEvent('end', response.data.result)
                self.shiftStart = self.passedDailyInspection = false
                // self.resetState()
                self.stateUpload()
                self.goHomeWithDelay()
              }
            })
            .catch(err => {
              console.log(err)
              self.showPreloader = false
              self.disableEndShiftButton = false
              if (!self.errorStatusAvaible(err) && self.isOnline) return self.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
              if (self.isOnline) self.showAlert(5, err.response.data.result.message)
              if (self.isOffline) {
                let time = self.getCurrentTime()
                self.showAlert(2, 'You are offline. The data has been saved and uploaded when online')
                self.saveEvent('end', time)
                self.shiftStart = self.passedDailyInspection = false
                self.goHomeWithDelay()
              }
            })
        }
      })
    },
    startShift () {
      let self = this
      this.$validator.validateAll({
        odometer: self.inspectionData.odometer,
        tireTread: self.inspectionData.tireTread,
        brakes: self.inspectionData.brakes,
        safetyEquipment: self.inspectionData.safetyEquipment,
        suppliesSafety: self.inspectionData.suppliesSafety,
        documentation: self.inspectionData.documentation,
        lights: self.inspectionData.lights
      }).then(async function (result) {
        if (result) {
          self.disableStartShiftButton = true
          let images = await self.getImagesFromIndexedDb(self.inspectionData.imagesOdometer)
          let inspectionDataObject = self.inspectionData
          let time = self.getCurrentTime()
          inspectionDataObject.imagesOdometer = images
          inspectionDataObject.time = time
          self.showPreloader = true
          self.$store.dispatch('startShift', inspectionDataObject)
            .then(response => {
              self.showPreloader = false
              self.disableStartShiftButton = false
              self.showAlert(2, 'Shift has been started')
              self.passedDailyInspection = true
              self.saveEvent('start', response.data.result)
              self.reloadInspectionData()
              self.stateUpload()
              self.goHomeWithDelay()
            })
            .catch(err => {
              console.log(err)
              self.showPreloader = false
              self.disableStartShiftButton = false
              if (!self.errorStatusAvaible(err) && self.isOnline) return self.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
              if (self.isOnline) self.showAlert(5, err.response.data.result.message)
              if (self.isOffline) self.showAlert(3, 'You are offline now. You need to be online during sending this data')
            })
        }
      })
    },
    reloadInspectionData () {
      this.inspectionData = { odometer: null, imagesOdometer: [], tireTread: null, brakes: null, safetyEquipment: null, suppliesSafety: null, documentation: null, lights: null, imagesOdometerEnd: [] }
    },
    goHomeWithDelay () {
      let self = this
      setTimeout(function () {
        self.goHomePage()
      }, 1500)
    },
    goHomePage () {
      this.$router.push('/')
    },
    getImagesFromIndexedDb (imagesIdArray) {
      let imagesArray = []
      return new Promise((resolve, reject) => {
        this.$db.images.each(function (item, cursor) {
          if (imagesIdArray.indexOf(item.id) > -1) {
            imagesArray.push(item.canvas)
          }
        }).then(() => {
          resolve(imagesArray.slice())
          console.log('Ok')
        }).catch(err => {
          reject(err)
        })
      })
    },
    saveEventResetForm (shiftType) {
      let time = this.getCurrentTime()
      this.saveEvent(shiftType, time)
      this.inspectionData = { odometer: null, imagesOdometer: [], tireTread: null, brakes: null, safetyEquipment: null, suppliesSafety: null, documentation: null, lights: null }
    },
    saveEvent (eventType, responseData) {
      let time = eventType === 'start' ? responseData.shiftStart : responseData.shiftEnd
      let date = parseInt(time) * 1000
      let data = this.$moment(date).format('MMMM Do YYYY')
      let shiftEvent = eventType === 'start' ? `Start shift - ${data}` : `End shift - ${data}`
      let shiftStatus = eventType === 'start'
      let shiftId = responseData.id
      this.$store.commit('addShiftEvent', shiftEvent)
      this.$store.commit('changeShiftStatus', shiftStatus)
      if (shiftId) this.$store.commit('setShiftId', shiftId)
    },
    update () {
      this.$db.tests.toArray().then(tests => {
        this.tests = tests
      })
    },
    // Create mixin for this
    // The same is in JobAction component
    takePicture (data) {
      this.showCamera = true
      this.photoType = data
      // Scroll screen to top
      window.scrollTo(0, 0)
      this.addClassToBody()
    },
    takeSignature () {
      this.showSignature = true
      this.addClassToBody()
    },
    closeCamera (data) {
      this.showCamera = false
      this[data[1][0]][data[1][1]] = data[0]
      this.removeClassFromBody()
    },
    addClassToBody () {
      let body = document.body
      body.classList.add('overflowbody')
    },
    removeClassFromBody () {
      let body = document.body
      body.classList.remove('overflowbody')
    },
    add (value) {
      this.$db.tests.add({
        id: '_' + Math.random().toString(36).substr(2, 9),
        label: value
      }).then(() => this.update())
    },
    remove (test) {
      this.$db.tests.where('id').equals(test.id).delete().then(() => this.update())
    },
    goHome () {
      this.$router.push('/')
    }
  },
  mixins: [alertMixin, timestampMixin, stateUpdateMixin, errorStatusMixin],
  computed: {
    shiftIsStarted: function () {
      return this.$store.state.shift.isStarted
    }
  },
  components: {
    camera
  }
}
</script>
<style scoped>
 .font-xl {
   font-size: 1.2rem;
 }
 .custom-badge {
   line-height: 46px;
   padding-top: 0;
   padding-bottom: 0;
   font-size: 85%;
 }
 .pointer {
   cursor: pointer;
 }
 .form-control {
   background-position: center right calc(0.375em + 0.1875rem);
 }
 .danger {
   color: #f5365c;
 }
 .pause {
   color: #2dce89;
 }
</style>
